export interface KeyCommandConfig {
  value: string // The value used for building the accelerator string (e.g., 'Ctrl')
  display: string // The value shown in the UI (e.g., 'Control')
}

export const keyCommands: KeyCommandConfig[] = [
  { value: 'Shift', display: 'Shift' },
  { value: 'Ctrl', display: 'Control' },
  { value: 'Alt', display: 'Alt/Option' },
  { value: 'Meta', display: 'Cmd/Win/Meta' },
]

export const allowedLetters = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
  'Up',
  'Down',
  'Left',
  'Right',
  'Enter',
  'Escape',
  'Space',
]

export const initialToggleStates: Record<string, boolean> = keyCommands.reduce(
  (acc, command) => {
    acc[command.value] = false
    return acc
  },
  {} as Record<string, boolean>,
)

export const parseKeyComboString = (
  keyComboStr: string | undefined,
): { newToggleStates: Record<string, boolean>; newLetter: string } | null => {
  if (!keyComboStr) {
    return null
  }

  const parts = keyComboStr.split('+').map((part) => part.trim())

  if (parts.length < 2) {
    return null
  }

  const letter = parts[parts.length - 1]
  const modifiers = parts.slice(0, parts.length - 1)

  if (!allowedLetters.includes(letter)) {
    return null
  }

  const newToggleStates = { ...initialToggleStates }
  let validModifiersFound = 0

  for (const part of modifiers) {
    const matchedCommand = keyCommands.find((kc) => kc.value === part) // Match against command.value

    if (matchedCommand) {
      newToggleStates[matchedCommand.value] = true // Set state using command.value
      validModifiersFound++
    } else {
      return null
    }
  }

  if (validModifiersFound === 0 || validModifiersFound !== modifiers.length) {
    return null
  }

  return { newToggleStates, newLetter: letter }
}
